(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/linear-progress", [], factory);
	else if(typeof exports === 'object')
		exports["linear-progress"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["linear-progress"] = factory();
})(this, function() {
return 